import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class UpdateUserInfo {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend
  ) {}

  async run(user_id, receive_newsletter): Promise<{ [key: string]: string; }> {
    let args = {
        user_id:user_id,
        receive_newsletter:receive_newsletter    
    }
    this.frontend.change_receive_newsletter_loaging_status(true)
    let res = await this.dispatcher.dispatch('update_user_info.data', args)
    this.frontend.change_receive_newsletter_loaging_status(false)
    return
  }
}